/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

/* eslint id-length: 0 */

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var FullMenu = (function (_Component) {
	_inherits(FullMenu, _Component);

	_createClass(FullMenu, null, [{
		key: 'propTypes',
		value: {
			'className': _react.PropTypes.string,
			'selected': _react.PropTypes.string,
			'navSections': _react.PropTypes.array.isRequired,
			'navSeries': _react.PropTypes.array.isRequired
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			'selected': 'home'
		},
		enumerable: true
	}]);

	function FullMenu(props) {
		_classCallCheck(this, _FullMenu);

		_Component.call(this, props);
		this.state = {
			isOpen: false
		};
		this.onDocumentClick = this.onDocumentClick.bind(this);
	}

	FullMenu.prototype.componentDidMount = function componentDidMount() {
		document.addEventListener('click', this.onDocumentClick);
	};

	FullMenu.prototype.componentWillUnmount = function componentWillUnmount() {
		document.removeEventListener('click', this.onDocumentClick);
	};

	FullMenu.prototype.onDocumentClick = function onDocumentClick(event) {
		var toggle = _reactDom2['default'].findDOMNode(this.refs.toggle);
		var menu = _reactDom2['default'].findDOMNode(this.refs.menu);

		if (toggle && toggle.contains(event.target)) {
			this.setState({ 'isOpen': !this.state.isOpen });
			event.preventDefault();
		} else if (menu && !menu.contains(event.target)) {
			this.setState({ 'isOpen': false });
		}
	};

	FullMenu.prototype.render = function render() {
		var _classNames3,
		    _this = this;

		var styles = require('./FullMenu.css');
		var selected = this.props.selected;

		// Build Sections
		var navSections = _lodash2['default'].map(this.props.navSections, function (name, index) {
			var _classNames;

			var linkStyles = _classnames2['default']((_classNames = {}, _classNames[styles.MenuLink] = true, _classNames[styles['MenuLink--here']] = selected === index, _classNames));

			return _react2['default'].createElement(
				'li',
				{ className: styles.MenuItem, key: index },
				_react2['default'].createElement(_reactRouter.Link, {
					activeClassName: styles['MenuLink--here'],
					className: linkStyles,
					dangerouslySetInnerHTML: { __html: name.name },
					onClick: function () {
						_this.setState({ 'isOpen': false });
					},
					to: '/section/' + name.slug
				})
			);
		});

		// Build Special Series
		var specialSeries = _lodash2['default'].map(this.props.navSeries, function (name, index) {
			var _classNames2;

			var linkStyles = _classnames2['default']((_classNames2 = {}, _classNames2[styles.MenuLink] = true, _classNames2[styles['MenuLink--here']] = selected === index, _classNames2));

			return _react2['default'].createElement(
				'li',
				{ className: styles.MenuItem, key: index },
				_react2['default'].createElement(_reactRouter.Link, {
					activeClassName: styles['MenuLink--here'],
					className: linkStyles,
					dangerouslySetInnerHTML: { __html: name.name },
					onClick: function () {
						_this.setState({ 'isOpen': false });
					},
					to: '/special-series/' + name.slug
				})
			);
		});

		/* Classes for all nav elements contained here */
		var toggleStyles = _classnames2['default']((_classNames3 = {}, _classNames3[styles.Toggle] = true, _classNames3[styles['Toggle--here']] = this.state.isOpen, _classNames3));

		return _react2['default'].createElement(
			'nav',
			{ className: (this.props.className ? this.props.className + ' ' : null) + styles.Nav },
			_react2['default'].createElement(
				'a',
				{ className: toggleStyles, href: '#content', ref: 'toggle' },
				_react2['default'].createElement('i', { className: styles.ToggleIcon })
			),
			this.state.isOpen ? _react2['default'].createElement(
				'div',
				{ className: styles.MenuContainer },
				_react2['default'].createElement(
					'div',
					{ className: styles.MenuBlock },
					_react2['default'].createElement(
						'ul',
						{ className: styles['Menu--columns'] },
						_react2['default'].createElement(
							'li',
							{ className: styles.MenuItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ to: '/', onClick: function () {
										_this.setState({ 'isOpen': false });
									} },
								'Front Page'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.MenuItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ to: '/section/daily-drip', onClick: function () {
										_this.setState({ 'isOpen': false });
									} },
								'The Drip'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.MenuItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ to: '/membership', onClick: function () {
										_this.setState({ 'isOpen': false });
									} },
								'Support Us'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.MenuItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ to: '/membership', onClick: function () {
										_this.setState({ 'isOpen': false });
									} },
								'Subscribe'
							)
						)
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.MenuBlock },
					_react2['default'].createElement(
						'h3',
						{ className: styles.MenuHeader },
						'Sections'
					),
					_react2['default'].createElement(
						'ul',
						{ className: styles['Menu--columns'] },
						navSections
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.MenuBlock },
					_react2['default'].createElement(
						'h3',
						{ className: styles.MenuHeader },
						'Special Series'
					),
					_react2['default'].createElement(
						'ul',
						{ className: styles.Menu },
						_react2['default'].createElement(
							'li',
							{ className: styles.MenuItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ to: '/special-series', onClick: function () {
										_this.setState({ 'isOpen': false });
									} },
								_react2['default'].createElement(
									'em',
									null,
									'See All'
								)
							)
						),
						specialSeries
					)
				)
			) : null
		);
	};

	var _FullMenu = FullMenu;
	FullMenu = _reactRedux.connect(function (state) {
		return {
			navSections: state.navSections.data,
			navSeries: state.navSpecialSeries.data
		};
	})(FullMenu) || FullMenu;
	return FullMenu;
})(_react.Component);

exports['default'] = FullMenu;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FullMenu/FullMenu.js
 ** module id = 679
 ** module chunks = 0
 **/